<script setup>
import { useRouter } from "vue-router";
import { useAuth } from "./useAuth"; // Подключаем наше глобальное хранилище

// Инициализируем роутре
const router = useRouter();

// Достаем статус авторизации и функцию выхода
const { isAuthenticated } = useAuth();

const handleLogin = async () => {
  // Перенаправляем пользователя на страницу авторизации
  router.push("/login");
};

// const handleLogout = () => {
//   logout(); // Удаляем токен и меняем статус
//   router.push("/login"); // Выкидываем на страницу входа
// };
</script>

<template>
  <div>
    <!-- prettier-ignore   -->
    <header class="sticky top-0 left-0 w-full bg-blueice z-50
      py-2"
    >    
    <!-- Центрируем контент, задаем максимальную ширину как в старом .wrapper
    и адаптивные отступы по краям (px-4, на больших экранах px-8) -->
    <!-- prettier-ignore   -->
    <nav class="container w-full max-w-[1635px] mx-auto px-4 sm:px-8 py-2 flex 
    items-center justify-between">
      <div class="flex items-center space-x-4">
        <a href="" class="text-white hover:text-white-900 font-standart
        font-display text-2xl md:text-[32px] font-standart">
          HandBox
        </a>
      </div>
      <div class="flex items-end space-x-4 xl:items-center ">
        <!-- Кнопка меню, для мобильных экранов -->
        <div class="lg:hidden">
          <button class="text-white hover:text-white-900 focus:outline-none cursor-pointer" @click="handleLogin">
          <!-- Иконка гамбургера -->
          <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
        </button>
        </div>
      </div>
      <!-- Обертка ссылок: скрыта до lg, показывается как flex от lg и выше -->
      <div class="hidden lg:flex items-center space-x-4 xl:space-x-6">
        <a href="" class="text-white hover:text-white-900 font-standart
        text-lg md:text-[20px] font-standart">
          Бесплатно
        </a>
        <a href="" class="text-white hover:text-white-900 font-standart
        text-xl md:text-[20px] font-standart">
          Практики и стажировки
        </a>
        <a href="" class="text-white hover:text-white-900 font-standart
        text-xl md:text-[20px] font-standart">
          О HandBox
        </a>
        <!-- <a href="" class="text-white hover:text-white-900 font-standart
        text-xl md:text-[20px] font-standart">
          Войти
        </a> -->
        
        <!-- Блок авторизованного пользователя -->
        <div v-if="isAuthenticated" class="flex items-center space-x-4 xl:space-x-6">
          <router-link to="/profile" class="text-white hover:text-white-900 font-standart text-xl 
          md:text-[20px] font-standart cursor-pointer">Профиль</router-link>
        </div>
        
        <!-- Блок гостя -->
        <div v-else class="flex items-center">
          <!-- При клике сразу переходим на страницу логина -->
          <button @click="handleLogin" class="text-white hover:text-white-900 font-standart text-xl 
          md:text-[20px] font-standart cursor-pointer">Войти</button>
        </div>
      </div>
    </nav>
    </header>
  </div>
</template>
